var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full-heigth" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            fullscreen: true,
            title: _vm.formData.id ? "編輯資料" : "新增資料",
            visible: _vm.dialogFormVisible,
            top: "2%",
            width: "90%",
          },
          on: {
            closed: _vm.onDialogClosed,
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.formLoading,
                  expression: "formLoading",
                },
              ],
              ref: "dynamicValidateForm",
              attrs: { model: _vm.formData },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "封面照", "label-width": _vm.formLabelWidth },
                },
                [
                  _c(
                    "div",
                    [
                      _c("span", [_vm._v("尺寸:840*480")]),
                      _c("Upload", {
                        ref: "uploadRef",
                        attrs: {
                          accept: ".jpg,.jpeg,.png",
                          limitText:
                            "圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB",
                          payload: _vm.formData,
                          "data-obj": _vm.fileObj,
                          "limit-file-count": 3,
                          "use-drag": false,
                          action: "ToursCombine/saveArticle",
                          "auto-upload": false,
                          "show-file-list": true,
                          "form-on-loading-parent": _vm.formLoading,
                          "btn-txt": "上傳",
                          "before-file-list": _vm.coverFileList,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "影片連結",
                    "label-width": _vm.formLabelWidth,
                    prop: "externalLink",
                    rules: [{ validator: _vm.validateLink, trigger: "blur" }],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      placeholder: "若有輸入影片連結，則封面會以影片優先顯示",
                    },
                    model: {
                      value: _vm.formData.externalLink,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "externalLink", $$v)
                      },
                      expression: "formData.externalLink",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "標題",
                    "label-width": _vm.formLabelWidth,
                    prop: "title",
                    rules: [
                      {
                        required: true,
                        message: "請輸入標題",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      maxlength: "100",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "title", $$v)
                      },
                      expression: "formData.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "國家",
                    "label-width": _vm.formLabelWidth,
                    prop: "country",
                    rules: [
                      { type: "array", message: "型別錯誤", trigger: "blur" },
                      {
                        required: true,
                        message: "請選擇國家",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      options: _vm.cascaderCountryOptions,
                      props: {
                        multiple: true,
                        value: "id",
                      },
                      "collapse-tags": "",
                    },
                    model: {
                      value: _vm.formData.country,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "country", $$v)
                      },
                      expression: "formData.country",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "項目及分類",
                    "label-width": _vm.formLabelWidth,
                    prop: "itemType",
                    rules: [
                      { type: "array", message: "型別錯誤", trigger: "blur" },
                      {
                        required: true,
                        message: "請選擇項目及分類",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      options: _vm.cascaderOptions,
                      props: {
                        multiple: true,
                        value: "id",
                        label: "title",
                        children: "types",
                      },
                      "collapse-tags": "",
                    },
                    model: {
                      value: _vm.formData.itemType,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "itemType", $$v)
                      },
                      expression: "formData.itemType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "內容",
                    "label-width": _vm.formLabelWidth,
                    prop: "articleContent",
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c("tinymce", {
                        ref: "tinymce",
                        attrs: { height: 300, type: 16 },
                        model: {
                          value: _vm.formData.articleContent,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "articleContent", $$v)
                          },
                          expression: "formData.articleContent",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "發文日期",
                    "label-width": _vm.formLabelWidth,
                    prop: "buildDate",
                    rules: [
                      {
                        required: true,
                        message: "請選擇發文日期",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      placeholder: "請選擇發文日期",
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.formData.buildDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "buildDate", $$v)
                      },
                      expression: "formData.buildDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "hashTags",
                    "label-width": _vm.formLabelWidth,
                    prop: "hashtags",
                    rules: [
                      { type: "array", message: "型別錯誤", trigger: "blur" },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        "allow-create": "",
                        placeholder: "請輸入關鍵字",
                        "remote-method": _vm.remoteMethod,
                        loading: _vm.loading,
                        "no-data-text": "無資料",
                        "value-key": "id",
                      },
                      model: {
                        value: _vm.formData.hashtags,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "hashtags", $$v)
                        },
                        expression: "formData.hashtags",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.title, value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "排序",
                    "label-width": _vm.formLabelWidth,
                    prop: "sort",
                    rules: [
                      {
                        required: true,
                        message: "請輸入排序",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off", type: "number" },
                    model: {
                      value: _vm.formData.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "sort", _vm._n($$v))
                      },
                      expression: "formData.sort",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onDialogClosed()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveData("dynamicValidateForm")
                    },
                  },
                },
                [_vm._v("儲 存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        { staticClass: "demo-form-inline", attrs: { inline: true } },
        [
          _vm.title == "全部"
            ? _c(
                "el-form-item",
                { attrs: { label: "項目篩選" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        placeholder: "選擇分類",
                      },
                      model: {
                        value: _vm.listQuery.items,
                        callback: function ($$v) {
                          _vm.$set(_vm.listQuery, "items", $$v)
                        },
                        expression: "listQuery.items",
                      },
                    },
                    _vm._l(_vm.itemOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.title, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "分類篩選" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    placeholder: "選擇分類",
                  },
                  model: {
                    value: _vm.listQuery.types,
                    callback: function ($$v) {
                      _vm.$set(_vm.listQuery, "types", $$v)
                    },
                    expression: "listQuery.types",
                  },
                },
                _vm._l(_vm.typeOptions, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.title, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "標題及HashTag查詢" } },
            [
              _c("el-input", {
                attrs: { placeholder: "輸入標題" },
                model: {
                  value: _vm.listQuery.qry,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "qry", $$v)
                  },
                  expression: "listQuery.qry",
                },
              }),
            ],
            1
          ),
          this.$route.meta.title !== "綜合討論區"
            ? _c(
                "el-form-item",
                { attrs: { label: "作者篩選" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        placeholder: "選擇作者",
                      },
                      model: {
                        value: _vm.listQuery.authors,
                        callback: function ($$v) {
                          _vm.$set(_vm.listQuery, "authors", $$v)
                        },
                        expression: "listQuery.authors",
                      },
                    },
                    _vm._l(_vm.authOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getList } },
                [_vm._v("查詢")]
              ),
              _c(
                "el-button",
                { attrs: { type: "success" }, on: { click: _vm.addData } },
                [_vm._v("建立")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                size: "mini",
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
              on: { "sort-change": _vm.changeSort },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "ID", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.id))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "封面照", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-image", {
                          staticStyle: { width: "100%", "aspect-ratio": "1/1" },
                          attrs: {
                            src: scope.row.externalLink
                              ? _vm.handleFormatVideoPic(scope.row.externalLink)
                              : scope.row.fileInfo !== null &&
                                scope.row.fileInfo.length > 0
                              ? scope.row.fileInfo[0].files[0].url
                              : "https://fakeimg.pl/280x160/",
                            fit: "contain",
                            "preview-src-list": _vm.fileUrl(scope.row.fileInfo),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "標題", width: "190" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.changeURL(row),
                              target: "_blank",
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { color: "rgb(64, 158, 255)" } },
                              [_vm._v(_vm._s(row.title))]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.title == "全部"
                ? _c("el-table-column", {
                    attrs: { align: "center", label: "項目", width: "140" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return _vm._l(
                              _vm.itemType(row.itemType),
                              function (item) {
                                return _c(
                                  "p",
                                  {
                                    key: item,
                                    staticStyle: { margin: "2px 0px" },
                                  },
                                  [_vm._v(" " + _vm._s(item) + " ")]
                                )
                              }
                            )
                          },
                        },
                      ],
                      null,
                      false,
                      1329425060
                    ),
                  })
                : _c("el-table-column", {
                    attrs: { align: "center", label: "分類", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", [
                              _vm._v(_vm._s(_vm.typeShow(row.types))),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
              _c("el-table-column", {
                attrs: { align: "center", label: "國家", width: "350" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input", {
                          attrs: {
                            rows: 6,
                            type: "textarea",
                            disabled: "",
                            value: _vm.showCountry(row.countryCascader),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "作者", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.authorName))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "hashtags", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.hashtagShow(row.hashtags))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "建立時間",
                  sortable: "custom",
                  width: "120",
                  prop: "BuildDate",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.dataTime(row.buildDate))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "排序",
                  sortable: "custom",
                  width: "80",
                  prop: "Sort",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.sort))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "點閱次數",
                  sortable: "custom",
                  width: "120",
                  prop: "ViewCount",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-tag", { attrs: { type: "primary" } }, [
                          _vm._v(_vm._s(row.viewCount)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "編輯", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "filter-item",
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-edit",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [_vm._v("編輯")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "刪除", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "filter-item",
                            attrs: {
                              size: "mini",
                              type: "danger",
                              icon: "el-icon-key",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteData(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 刪除 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "padding-top": "0", "margin-top": "15px" },
        attrs: {
          layout: "total, prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }